<template>
  <div class="$attrs.class">
    <label class="upper">PUBLIC DETAILS</label>
    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="form-row">
          <div class="col-12  col-md-9">
            <input-text
              id="name"
              v-model="name"
              v-validate="'required'"
              name="name"
              data-vv-name="name"
              data-vv-as="college name"
              label="College Name"
              type="text"
              required
              :error="errors.first('name')"
            />
          </div>
          <div class="col-12 col-md-3">
            <input-select
              id="isMember"
              v-model="isMember"
              name="isMember"
              label="Is Member School"
              type="checkbox"
              :options="[
                { id: 'true', display_label: 'Yes' },
                { id: 'false', display_label: 'No' }
              ]"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <input-text
              id="counselingCenterLocation"
              v-model="counselingCenterLocation"                   
              name="counselingCenterLocation"
              label="Counseling Center Location"
              type="text"
            />
          </div>

          <div class="col-12 col-md-6">
            <input-text
              id="counselingCenterPhone"
              v-model="counselingCenterPhone"
              name="counselingCenterPhone"
              label="Counseling Center Phone"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="campusCrisisInfo"
              v-model="campusCrisisInfo"
              name="campusCrisisInfo"
              label="Campus Crisis Info"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="messageForNewUserPrompt"
              v-model="messageForNewUserPrompt"
              name="messageForNewUserPrompt"
              label="Message for new user prompt"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <h3>New user prompt format guide</h3>
            <p>The new user prompt text is considered HTML. Use the following tips to format text. If you intend to use HTML formating more advanced than the below, please run it by IT first!</p>
            <p><b>Please review all changes that include HTML in the demo.bettermynd.com environment before saving them in production!</b></p>
            <ul>
              <li>
                To have line breaks, do one of the following:
                <ul>
                  <li>Surround a block of text with "&lt;p&gt;Text Here!!&lt;/p&gt;"</li>
                  <li>Put &lt;br&gt; at the end of the line.</li>
                </ul>
              </li>
              <li>
                To make a clickable email address, do the following: &lt;a href="mailto:REPLACE_ME_WITH_EMAIL"&gt;REPLACE_ME_WITH_EMAIL&lt;/a&gt;
              </li>
              <li>
                To make a clickable link, do the following: &lt;a href="REPLACE_ME_WITH_URL"&gt;REPLACE_ME_WITH_WHAT_THE_CLICKABLE_LINK_SHOULD_SAY&lt;/a&gt;
              </li>
            </ul>
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-wide mt-4"
        >
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'General',

  components: {
    FormComponent,
    InputText,
    InputTextArea,
    InputSelect,
  },

  inject:['school'],

  data() {
    return {
      name: '',
      campusCrisisInfo: '',
      messageForNewUserPrompt: '',
      counselingCenterLocation: '',
      counselingCenterPhone: '',
      isMember: 'false',
    }
  },

  mounted() {
    this.name = this.school.general.name;
    this.campusCrisisInfo = this.school.general.campusCrisisInfo;
    this.messageForNewUserPrompt = this.school.general.messageForNewUserPrompt;
    this.counselingCenterLocation = this.school.general.counselingCenterLocation;
    this.counselingCenterPhone = this.school.general.counselingCenterPhone;
    this.isMember = this.school.general.isMember ? 'true' : 'false';
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (!isValid)
        return;

      this.errors.clear();

      try {
        await this.school.updateGeneral({
          name: this.name,
          campusCrisisInfo: this.campusCrisisInfo,
          messageForNewUserPrompt: this.messageForNewUserPrompt,
          counselingCenterLocation: this.counselingCenterLocation,
          counselingCenterPhone: this.counselingCenterPhone,
          isMember: this.isMember === 'true',
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'College Saved!',
        });
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save college. Please try again!', error: true,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
  }
</style>